import { toast } from "react-toastify";
import axios from "axios";
import saveAs from "file-saver";
import {
  GetInterlockPdf,
} from "../../services/users.service";
// Custom Imports
import { EmptyLocalStorage } from "../auth/auth.service";


/**
 * Uploads CSV and ZIP files for a given client, fetches HTML report (with embedded page-break CSS),
 * injects it into a hidden off-screen container, and converts it to a true A4 PDF using html2pdf.js.
 * Fits content by width and ensures each page matches A4 dimensions exactly.
 * Expects `id`, `formData`, `setDisableDownload`, and `history`.
 */
const onGenerateInterlockReport = async ({ id, formData, setDisableDownload, history }) => {
  setDisableDownload(true);

  await GetInterlockPdf(
      id,
      formData
    )
      .then((result) => {
  
        if (result.data.success) {
          toast.success(result.data.message);
          console.log("data: ", result.data.data.url);
          saveAs(result.data.data.url, result.data.data.name);
          setDisableDownload(false);
        } else {
          toast.error(result.message);
          setDisableDownload(false);
        }
      })
      .catch((error) => {
        setDisableDownload(false);
        if (error.response.status == 401) {
          EmptyLocalStorage();
          history.push("/");
        } else {
          return toast.error(error.response.data.message);
        }
      });
  // const token = localStorage.getItem('AUTH_ACCESS_TOKEN');
  // const url = `reports/${id}/download_interlock_report`;

  // try {
  //   // Fetch HTML string
  //   const result = await axios.post(url, formData, {
  //     headers: {
  //       "Content-Type": "multipart/form-data",
  //       "Authorization": `Token ${token}`
  //     },
  //     responseType: "application/json",
  //     timeout: 300000 // 5 minutes in milliseconds
  //   });
  //   let data = result.data;
  //   console.log("data: ", data);
  //   if (data.success) {
  //     toast.success(data.message);
  //     console.log("data: ", data.data.url);
  //     saveAs(data.data.url, data.data.name);
  //     setDisableDownload(false);
  //   } else {
  //     toast.error(result.message);
  //     setDisableDownload(false);
  //   }

  // } catch (error) {
  //   if (error.response && error.response.status === 401) {
  //     EmptyLocalStorage();
  //     history.push("/");
  //   } else {
  //     toast.error(error.response?.data?.message || error.message);
  //   }
  // } finally {
  //   setDisableDownload(false);
  // }
};

export default onGenerateInterlockReport;
